import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Card, message, notification, Modal } from "antd";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { BiCheck } from "react-icons/bi";
import logo from "../../../assets/frontendassets/logo.jpg";
import { checkUsernameAvailability, createRazorpayOrder, getallproduct, getallproducts, getCustomerByID, getHomePageProducts, payonline, storeOrder, storeTripodSevenpodOrder, verifyPayment  } from "../../../utils/API";
import ThankYou from "../Cart/ThankYou";


const { Option } = Select;

const SevenpodPayonlineUser: React.FC = () => {
  const [productData, setProductData] = React.useState<any>([]);
  const [form] = Form.useForm();
  const [sponsorId, setSponsorId] = React.useState<string | null>(null);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [transactionId, setTransactionId] = useState<string>("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [isUsernameAvailable, setIsUsernameAvailable] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedAddress = localStorage.getItem("address");
    const storedPincode = localStorage.getItem("pincode");

    if (storedAddress) setAddress(storedAddress);
    if (storedPincode) setPincode(storedPincode);
  }, []);

  useEffect(() => {

    getHomePageProducts()
      .then((response) => {
        setProductData(response.products.filter((product: any) => product.isUpcoming === false));
      })
      .catch((error) => {
        message.error("Network error. Please try again.");
      });


  }, [form]);

  useEffect(() => {
    if (username) {
      const checkAvailability = async () => {
        try {
          const available = await checkUsernameAvailability(username);
          setIsUsernameAvailable(available);
        } catch (error) {
          console.error('Error checking username availability:', error);
        }
      };

      const delayDebounceFn = setTimeout(() => {
        checkAvailability();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setIsUsernameAvailable(null);
    }
  }, [username]);

  const handleUsernameChange = (e: any) => {
    setUsername(e.target.value);
    form.setFieldsValue({ username: e.target.value });
  };

  const validateUsername = (value : any) => {
    const regex = /^RPDXA/;
    if (regex.test(value)) {
      setIsUsernameAvailable(true);  // Mock availability check
    } else {
      setIsUsernameAvailable(false);
    }
  };

  const validateFormat = (_ : any, value : any) => {
    const regex = /^RPDXA/;
    if (value && !regex.test(value)) {
      return Promise.reject(new Error('Username must start with "RPDXA"'));
    }
    return Promise.resolve();
  };

//   const handlePayment = async (value: any) => {
//     setIsLoading(true);
  
//     // Fetch selected product IDs
//     const selectedProductIds = value.productId;
  
//     // Check minimum product selection
//     if (!selectedProductIds || selectedProductIds.length < 7) {
//       setIsLoading(false);
//       return message.error("You must select at least 7 products.");
//     }
  
//     // Validate address and pincode
//     if (!value.address || !value.pincode) {
//       setIsLoading(false);
//       return message.error("Please enter address and pincode.");
//     }
  
//     let totalAmount = 0; // Variable to hold the total amount for all products
  
//     // Iterate over selected products and create orders
//     const orderPromises = selectedProductIds.map(async (productId: string) => {
//       const product = productData.find((p: any) => p._id === productId);
  
//       // Check if the product exists
//       if (!product) {
//         throw new Error("Invalid product selected");
//       }
  
//       // Calculate total amount for all products
//       totalAmount += product.discountedPrice;
  
//       // Order data for each product
//       const orderData = {
//         amount: parseFloat(product.discountedPrice) * 100, // Amount in paise (required by Razorpay)
//         currency: "INR",
//         receipt: `receipt_${productId}`,
//         orderItems: [
//           {
//             productId: productId,
//             quantity: 1,
//             amount: parseFloat(product.price),
//           },
//         ],
//         deferAmount: product.discountedPrice,
//         totalMrp: product.price,
//         totalDiscount: product.discountedPrice,
//         email: value.email,
//         totalIp: product.ipQty,
//         address: value.address,
//         pincode: value.pincode,
//         paymentMethod: "Razorpay",
//         transactionId: transactionId, // Assumes transactionId is initialized elsewhere
//         firstName: value.firstName,
//         lastName: value.lastName,
//         mobileNo: value.mobileNo,
//       };
  
//       try {
//         // Create Razorpay order for each product
//         const order = await createRazorpayOrder(orderData);
//         return order; // Return the created order
//       } catch (error) {
//         console.error("Error creating order:", error);
//         throw error; // Propagate error if order creation fails
//       }
//     });
  
//     try {
//       // Wait for all orders to be created
//       await Promise.all(orderPromises);
//       console.log("key" , process.env.REACT_APP_RAZOR_PAY_KEY_ID 
// )
//       // Initialize Razorpay payment for the total amount
//       const options = {
//         key: process.env.REACT_APP_RAZOR_PAY_KEY_ID 
// , // Your Razorpay key
//         amount: (totalAmount * 100).toString(), // Total amount in paise
//         currency: "INR",
//         image: logo, // Replace with your logo
//         name: "Rapidexie", // Your company name
//         description: "Test Transaction", // Payment description
//         handler: async function (response: any) {
//           const paymentData = {
//             razorpay_order_id: response.razorpay_order_id,
//             razorpay_payment_id: response.razorpay_payment_id,
//             razorpay_signature: response.razorpay_signature,
//           };
  
//           try {
//             // Verify payment
//             const verifyResult = await verifyPayment(paymentData);
//             if (verifyResult === "OK") {
//               setTransactionId(response.razorpay_payment_id);
//               setIsModalVisible(true);
//               message.success("Payment successful!");
//             } else {
//               message.error("Payment verification failed.");
//             }
//           } catch (error) {
//             message.error("Error verifying payment. Please try again.");
//             console.error("Payment verification error:", error);
//           }
//         },
//         prefill: {
//           name: `${value.firstName} ${value.lastName}`, // Prefill with user's full name
//           email: value.email,
//           contact: value.mobileNo,
//         },
//         theme: {
//           color: "#F37254", // Custom theme color
//         },
//       };
  
//       // Open the Razorpay payment window
//       const rzp = new (window as any).Razorpay(options);
//       rzp.open();
//     } catch (error) {
//       message.error("An error occurred while processing your payment.");
//       console.error("Payment process error:", error);
//     } finally {
//       setIsLoading(false); // Stop the loading state
//     }
//   };
const handlePayment = async (value: any) => {
  setIsLoading(true);

  const selectedProductIds = value.productId;

  // Check minimum product selection
  if (!selectedProductIds || selectedProductIds.length < 7) {
    setIsLoading(false);
    return message.error("You must select at least 7 products.");
  }

  // Validate address and pincode
  if (!value.address || !value.pincode) {
    setIsLoading(false);
    return message.error("Please enter address and pincode.");
  }

  const orderDataList: any[] = []; // Store order data for all orders
  let totalDiscountedAmount = 0;

  // Helper function to handle individual payments
  const handleIndividualPayment = async (productId: string, transactionId: string) => {
    const product = productData.find((p: any) => p._id === productId);

    if (!product) {
      throw new Error("Invalid product selected");
    }

    // totalDiscountedAmount += product.discountedPrice;
    totalDiscountedAmount = form.getFieldValue('amount');
    // const amountValue = form.getFieldValue('amount');
    const selectedProduct = selectedProductIds
      .map((id: any) => productData.find((p: any) => p._id === id))
      .filter((product:any) => product);

      const totalIpQty = selectedProduct.reduce((sum:any, product:any) => sum + product.ipQty, 0);
      const totalAmount = selectedProduct.reduce((sum:any, product:any) => sum + product.price, 0);
      const selectedProductName = selectedProduct.map((product:any) => product.name);
      const orderItems = selectedProduct.map((product:any) => ({
        productId: product._id,
        quantity: 1,
        amount: parseFloat(product.price),
      }));
    // console.log('Amount:',totalIpQty, totalAmount, (totalDiscountedAmount * 100).toString(),);
    console.log("selectedProductName", selectedProductName);
    const orderData = {
      // amount: parseFloat(product.discountedPrice) * 100, // Amount in paise
      amount: (totalDiscountedAmount * 100).toString(),
      currency: "INR",
      receipt: `receipt_${productId}`,
      orderItems: orderItems,
      deferAmount: 0,
      totalMrp: totalAmount,
      totalDiscount: totalDiscountedAmount,
      email: value.email,
      totalIp: totalIpQty,
      address: value.address,
      pincode: value.pincode,
      paymentMethod: "Razorpay",
      transactionId: transactionId,
      firstName: value.firstName,
      lastName: value.lastName,
      mobileNo: value.mobileNo,
    };

    try {
      // Create Razorpay order for the current product
      const order = await createRazorpayOrder(orderData);
      const { id: order_id, currency, amount } = order;
      // console.log("order", order);
      if (!order || !order.id) {
        throw new Error("Failed to create Razorpay order");
      }

      const options = {
        key: process.env.REACT_APP_RAZOR_PAY_KEY_ID,
        // amount: (product.discountedPrice * 100).toString(),
        // currency: "INR",
        amount:  amount.toString(),
        currency: currency,
        image: logo,
        name: "Rapidexie",
        description: `Payment for Product ${selectedProductIds}`,
        order_id: order_id,
        handler: async function (response: any) {
          console.log("Payment response:", response);
          const paymentData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          };

          try {
            const verifyResult = await verifyPayment(paymentData);
            if (verifyResult === "OK") {
              let transactionId = response.razorpay_payment_id;
              // message.success(`Payment successful for product ${selectedProductName}`);
              try {
                const response = await storeTripodSevenpodOrder({ ...orderData, transactionId });
                setTransactionId(transactionId);

                setIsModalVisible(true);
              } catch (error) {
                console.error("Error storing order:", error);
                message.error("An error occurred while processing your payment. Please try again.");
              }
              // Proceed to the next product after payment is successful
              // const nextProductIndex = selectedProductIds.indexOf(productId) + 1;
              // if (nextProductIndex < selectedProductIds.length) {
              //   await handleIndividualPayment(selectedProductIds[nextProductIndex], transactionId);
              // } else {
                message.success("Payments completed!");
              // }
            } else {
              message.error("Payment verification failed.");
            }
          } catch (error) {
            message.error("Error verifying payment. Please try again.");
            console.error("Payment verification error:", error);
          }
        },
        prefill: {
          name: `${value.firstName} ${value.lastName}`,
          email: value.email,
          contact: value.mobileNo,
        },
        theme: {
          color: "#F37254",
        },
      };

      // Open Razorpay payment window
      const rzp = new (window as any).Razorpay(options);
      rzp.open();

    } catch (error) {
      console.error("Error creating order:", error);
      throw error;
    }
  };

  try {
    // Start with the first product
    await handleIndividualPayment(selectedProductIds[0], transactionId);
  } catch (error) {
    message.error("An error occurred while processing your payment.");
    console.error("Payment process error:", error);
  } finally {
    setIsLoading(false);
  }
};
  

  const calculateTotalAmount = (selectedProductIds : any) => {
    const totalAmount = selectedProductIds.reduce((sum : any, productId : any) => {
      const selectedProduct = productData.find((product : any) => product._id === productId);
      return sum + (selectedProduct ? selectedProduct.discountedPrice : 0);
    }, 0);
    form.setFieldsValue({ amount: totalAmount }); // Set the total amount in the form field
  };

  const handleLoginSuccess = () => {
    setIsLoginModalVisible(false);
    handlePayment({});
  };

  return (
    <div className="lg:mt-48 xl:mt-46 md:mt-36 sm:mt-36 xs:mt-12 mt-12 md:pl-40 md:pr-40  pt-12 pb-3">
      <Modal
        footer={null}
        title=""
        closable={false}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      >
        <ThankYou transactionId={transactionId} />
      </Modal>
      <Form
  onValuesChange={(changedValues, allValues) => {
    if (changedValues.productId) {
      calculateTotalAmount(changedValues.productId);
    }
  }}
  form={form}
  onFinish={handlePayment}
  className="bg-white"
>
        <Row className="m-2" align={"middle"}>
          <Col
            xs={24}
            sm={24}
            md={9}
            xl={6}
            xxl={6}
            className="d-flex justify-content-start font-bold"
          >
            <h2 className="text-2xl">Pay Online</h2>
          </Col>
        </Row>
        <Row justify={"center"} className=" pt-5 border border-warning-2 bg-white rounded-md">

          {/* <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  User Id
                </label>
              </Col>
              <Col span={12}>
                <Form.Item name="username" 
                   rules={[

                    { validator: validateFormat }
                  ]}
                >
                  <Input
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Your Direct Seller Id"
                    value={username}
                    onChange={handleUsernameChange}
                  />
                  {isUsernameAvailable !== null && (
                    <div style={{ color: isUsernameAvailable ? 'green' : 'red' }}>
                      {isUsernameAvailable ? 'Id is Valid' : 'Id is invalid'}
                    </div>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Col> */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  First Name <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="firstName"
                  rules={[
                    { required: true, message: "Please enter your First Name!" },
                  ]}
                >
                  <Input
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter First Name"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Last Name <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="lastName"
                  rules={[
                    { required: true, message: "Please enter your Last Name!" },
                  ]}
                >
                  <Input
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Last Name"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Email id <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: "Please enter your Email!" }]}>
                  <Input
                    type="email"
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Email id"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Mobile Number <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="mobileNo"
                  rules={[
                    { required: true, message: "Please enter your Mobile Number!" },

                  ]}
                >
                  <Input
                    type="number"
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Mobile Number"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Amount <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="amount"
                  rules={[
                    { required: true, message: "Please enter the Amount!" },

                  ]}
                >
                  <Input
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Amount"
                    type="number"
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Product <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
              <Form.Item
  name="productId"
  rules={[
    {
      required: true,
      message: "Please select at least 3 products!",
    },
    {
      validator: (_, value) => {
        if (!value || value.length < 7) {
          return Promise.reject("You must select at least 7 products");
        }
        return Promise.resolve();
      },
    },
  ]}
>
  <Select
    mode="multiple"  // Allow multiple selections
    size="large"
    className="rounded border border-1"
    placeholder="Select Product"
    allowClear
    showSearch
    optionFilterProp="label"
    filterOption={(input : any, option : any) =>
      option?.label.toLowerCase().includes(input.toLowerCase())
    }
  >
    {productData.map((product : any) => (
      <Option key={product._id} value={product._id} label={product.name}>
        {product.name} - ₹{product.discountedPrice}
      </Option>
    ))}
  </Select>
</Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Address <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="address"
                  rules={[
                    { required: true, message: "Please enter your Address!" },
                  ]}
                >
                  <Input.TextArea
                    rows={3}
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Address"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white" justify={"center"}>
              <Col span={4} className="d-flex justify-content-start me-5 bg-white mb-5">
                <label className="font-bold">
                  Pincode <span className="text-danger">*</span>
                </label>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="pincode"
                  rules={[
                    { required: true, message: "Please enter your Pincode!" },
                  ]}
                >
                  <Input
                    type="number"
                    size="large"
                    className="rounded border border-1"
                    placeholder="Enter Pincode"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>



          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row justify={"center"} className="bg-white">
              <Col
                xs={18}
                sm={18}
                md={12}
                xl={8}
                xxl={6}
                className="bg-white mb-3 d-flex justify-content-center"
              >
                <Form.Item>
                  <button
                    type="submit"
                    className={`px-4 py-2 rounded ${isLoading
                        ? 'bg-gray-500 text-white cursor-not-allowed'
                        : isUsernameAvailable === false
                          ? 'bg-orange-300 text-white cursor-not-allowed'
                          : 'bg-orange-500 text-white hover:bg-blue-600'
                      }`}
                    disabled={isLoading || isUsernameAvailable === false}
                  >
                    {isLoading ? 'Processing...' : 'Pay Now'}
                  </button>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SevenpodPayonlineUser;
